module.exports = __webpack_public_path__ + "static/media/mailbox.e323ed8d.svg";